import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildLegalHead } from "@/lib/legalSeo";

export const Route = createFileRoute("/do-not-sell")({
  head: () => buildLegalHead("/do-not-sell"),
  component: lazyRouteComponent(() => import("@/pages/DoNotSell")),
});
